import styled, { css } from 'styled-components';

export const Box = styled.div<{ $zIndex?: number }>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.palette.overlay['60']};
  pointer-events: none;

  ${({ $zIndex }) =>
    $zIndex &&
    css`
      z-index: ${$zIndex};
    `}
`;

export const Text = styled.span<{ $fontSize: number; $paddingTop?: number }>`
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  font-weight: 700;
  font-style: normal;
  color: ${({ theme }) => theme.palette.system.white};

  ${({ $paddingTop }) =>
    $paddingTop &&
    css`
      padding-top: ${$paddingTop}px;
    `}
`;
